import { OtherString } from '../otherString';
import { AnnotationClassName } from '../snapshot/classificationClass';
import { ClassificationLocation } from '../snapshot/classificationLocation';
import { z } from 'zod';

const DsiAnnotationBase = z.object({
    id: z.string(),
    location: ClassificationLocation,
    annotationClass: AnnotationClassName.or(OtherString),
    deletedBy: z.string().nullish(),
    deletedOn: z.string().nullish(),
});

export const DsiAnnotation = z.intersection(
    DsiAnnotationBase,
    z.discriminatedUnion('detectionType', [
        z.object({
            // User manually added this annotation -> no detection to connect it to
            detectionType: z.literal('manual'),
            detectionHash: z.null(),
            acceptedWithoutChange: z.literal(false),
        }),
        z.object({
            // User accepted/modified detection from NN
            detectionType: z.literal('automatic'),
            detectionHash: z.string(),
            acceptedWithoutChange: z.boolean(),
        }),
    ]),
);
export type DsiAnnotation = z.infer<typeof DsiAnnotation>;
